import React, { useEffect } from 'react';

const BuyMeCoffee = () => {
    useEffect(() => {
        // Dynamically load Buy Me a Coffee script
        const script = document.createElement('script');
        script.setAttribute('data-name', 'BMC-Widget');
        script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js';
        script.setAttribute('data-cfasync', 'false');
        script.setAttribute('data-id', 'fatreeg');
        script.setAttribute('data-description', 'Support me on Buy me a coffee!');
        script.setAttribute('data-message', 'Thanks for clicking! Help me with hosting fees if you\'re having fun :)');
        script.setAttribute('data-color', '#FF813F');
        script.setAttribute('data-position', '');
        script.setAttribute('data-x_margin', '0');
        script.setAttribute('data-y_margin', '0');
        
        script.onload = function() {
            const evt = document.createEvent('Event');
            evt.initEvent('DOMContentLoaded', false, false);
            window.dispatchEvent(evt);
        };

        // Check if container exists before appending
        const container = document.getElementById('bmc-wbtn');
        if (container && !container.querySelector('script[data-name="BMC-Widget"]')) {
            container.appendChild(script);
        }

        return () => {
            // Cleanup on unmount
            if (container && container.contains(script)) {
                container.removeChild(script);
            }
        };
    }, []);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '30px auto',
            padding: '20px',
            maxWidth: '500px'
        }}>
            <div style={{
                marginBottom: '15px',
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '16px',
                fontWeight: '500'
            }}>
                Enjoying the game? Support the developer! ☕
            </div>
            <div id="bmc-wbtn" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60px'
            }}>
                <a href="https://www.buymeacoffee.com/fatreeg" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   style={{
                       display: 'inline-flex',
                       alignItems: 'center',
                       padding: '10px 24px',
                       backgroundColor: '#FF813F',
                       color: 'white',
                       borderRadius: '8px',
                       textDecoration: 'none',
                       fontSize: '16px',
                       fontWeight: 'bold',
                       transition: 'transform 0.2s, box-shadow 0.2s',
                       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                   }}
                   onMouseEnter={(e) => {
                       e.target.style.transform = 'translateY(-2px)';
                       e.target.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
                   }}
                   onMouseLeave={(e) => {
                       e.target.style.transform = 'translateY(0)';
                       e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                   }}
                >
                    <img 
                        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" 
                        alt="Buy me a coffee" 
                        style={{ height: '24px', marginRight: '10px' }}
                    />
                    <span>Buy me a coffee</span>
                </a>
            </div>
            <div style={{
                marginTop: '10px',
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: '13px',
                fontStyle: 'italic'
            }}>
                Your support helps keep the servers running! 🚀
            </div>
        </div>
    );
};

export default BuyMeCoffee;